export interface DemoDataset {
    id: string;
    name: string;
    category: string;
    lineCount: string;
    sampleCount: string;
    resolution: {
        width: number;
        height: number;
    };
    fileName: string;
    publicPath: string;
    description: string;
}

export const DEMO_DATASETS: DemoDataset[] = [
    {
        id: 'weather',
        name: 'ACIS Temperature',
        category: 'Time series',
        lineCount: '6,187 stations',
        sampleCount: '293,175 values',
        resolution: { width: 1000, height: 500 },
        fileName: 'weather.csv',
        publicPath: 'datasets/weather.csv',
        description: 'Weekly maximum temperature series from US weather stations. The seasonal envelope is dense, while structure-guided corridors reveal a north-south climate split.',
    },
    {
        id: 'france-aviation',
        name: 'France Aviation',
        category: 'Flight trajectories',
        lineCount: '5,360 flights',
        sampleCount: '147,077 samples',
        resolution: { width: 800, height: 700 },
        fileName: 'france-aviation.csv',
        publicPath: 'datasets/france-aviation.csv',
        description: 'Geolocated aircraft trajectories over France. Regular long-range routes dominate the density, with smaller aircraft, loops, holding patterns, and recording artifacts in weaker structures.',
    },
    {
        id: 'dti',
        name: 'DTI Fibers',
        category: 'Medical fibers',
        lineCount: '12,059 fibers',
        sampleCount: '918,780 samples',
        resolution: { width: 700, height: 700 },
        fileName: 'dti.csv',
        publicPath: 'datasets/dti.csv',
        description: 'A sampled tractography projection from a 120,593-fiber brain dataset. It exposes overlapping anatomical bundles while preserving the original fiber geometry.',
    },
    {
        id: 'mediterranean-sea',
        name: 'Mediterranean Sea Trajectories',
        category: 'Vessel trajectories',
        lineCount: '2,000 tracks',
        sampleCount: '1,924,000 samples',
        resolution: { width: 748, height: 578 },
        fileName: 'mediterranean-sea-trajectory.csv',
        publicPath: 'datasets/mediterranean-sea-trajectory.csv',
        description: 'Large maritime movement traces across the Mediterranean Sea. Dense shipping corridors and crossings make it useful for inspecting route consistency.',
    },
    {
        id: 'hellenic-trench-ais',
        name: 'Hellenic Trench AIS',
        category: 'Ship trajectories',
        lineCount: '10,000 tracks',
        sampleCount: '775,946 samples',
        resolution: { width: 706, height: 577 },
        fileName: 'ship-simplified-rdp-0.0005.csv',
        publicPath: 'datasets/ship-simplified-rdp-0.0005.csv',
        description: 'Simplified AIS ship tracks around the Hellenic Trench. The data supports vessel-route analysis in a region where traffic patterns matter for marine habitat risk.',
    },
    {
        id: 'stock',
        name: 'Stock Prices',
        category: 'Financial series',
        lineCount: '4,393 symbols',
        sampleCount: '552,605 samples',
        resolution: { width: 1000, height: 500 },
        fileName: 'stock.csv',
        publicPath: 'datasets/stock.csv',
        description: 'Historical stock-price time series normalized into line ensembles. Use it to compare broad market movement and structurally unusual price paths.',
    },
    {
        id: 'hard-drive',
        name: 'Hard Drive Health',
        category: 'Device series',
        lineCount: '2,996 drives',
        sampleCount: '79,359 samples',
        resolution: { width: 1000, height: 500 },
        fileName: 'hard-drive.csv',
        publicPath: 'datasets/hard-drive.csv',
        description: 'Hard-drive telemetry traces over device lifetime. The curves make maintenance trends, degradation patterns, and unusual drive behavior visible as line structure.',
    },
];
